import React from 'react';
import GenericSearchForm from '../GenericSearch/GenericSearchForm';

const UsersSearchForm = (props) => {
  const fields = [
    {
      id: 'users_search_form_username_field',
      key: 'username',
      label: 'Username',
      placeholder: 'Username',
      type: 'text',
      gridProps: { xs: 12, sm: 4, lg: 3, xl: 2 }
    },
    {
      id: 'users_search_form_email_field',
      key: 'email',
      label: 'Email',
      placeholder: 'Email',
      type: 'text',
      gridProps: { xs: 12, sm: 4, lg: 3, xl: 2 }
    },
    {
      id: 'users_search_form_phone_number_field',
      key: 'phone_number',
      label: 'Phone number',
      placeholder: 'Phone number',
      type: 'text',
      gridProps: { xs: 12, sm: 4, lg: 2, xl: 2 }
    },
    {
      id: 'users_search_form_status_field',
      key: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { id: 'status_field_all', value: '', label: 'All' },
        { id: 'active', value: 'active', label: 'Active' },
        { id: 'blocked', value: 'blocked', label: 'Blocked' }
      ],
      gridProps: { xs: 12, sm: 4, lg: 2, xl: 2 }
    },
    {
      id: 'users_search_form_user_role_field',
      key: 'user_role',
      label: 'User Role',
      type: 'select',
      options: [
        { id: 'user_role_field_all', value: '', label: 'All' },
        { id: 'admin', value: 'admin', label: 'Admin' },
        { id: 'restricted', value: 'restricted', label: 'Restricted' }
      ],
      gridProps: { xs: 12, sm: 4, lg: 2, xl: 2 }
    }
  ];

  return <GenericSearchForm {...props} fields={fields} />;
};

export default UsersSearchForm;